
import Vue from 'vue'
import Component from 'vue-class-component'
import { INotificationService } from '@/services/NotificationService'
import TempAccountService from '@/services/TempAccountService'
import ErrorHandlerService from '@/services/ErrorHandlerService'
import UserCSV from '@/models/userCSV'
import GridHeader from '@/models/gridHeader'
import CardTable from '../components/Layout/CardTable.vue'
import CsvExportMassInsert from '../components/Users/CsvExportMassInsert.vue'
import CardTitle from '../components/Atomic/CardTitle.vue'
import HelpTooltip from '../components/Atomic/HelpTooltip.vue'
import BlueButton from '../components/Atomic/BlueButton.vue'
import { State } from 'vuex-class'
import {User} from '../store/index'
import ToolTipButton from '@/components/Atomic/ToolTipButton.vue'

@Component({
  components: {
    ToolTipButton,
    CardTable,
    CsvExportMassInsert,
    CardTitle,
    HelpTooltip,
    BlueButton,
  },
})
export default class UserMassInsert extends Vue {
  @State('user') private currentUser!: User
  private file: string
  private users: UserCSV[]
  private usersToExport: UserCSV[]
  private $notificationService: INotificationService = {} as any
  private errorHandlerService: ErrorHandlerService = new ErrorHandlerService()
  private jsonMeta: any
  private jsonFields: any
  private lastImportedFilename: string = ''
  private isPending: boolean = false
  private headers: GridHeader[] = []

  constructor() {
    super()
    this.file = ''
    this.jsonFields = {}
    this.jsonMeta = [{ key: 'charset', value: 'utf-8' }]
    this.users = []
    this.usersToExport = []
  }

  private mounted() {
  this.createHeaders()
  }

  private createHeaders() {
    this.headers.push(new GridHeader(this.$t('LastName').toString(), 'nom', 'left', true, 150))
    this.headers.push(new GridHeader(this.$t('FirstName').toString(), 'prenom', 'left', true, 100))
    this.headers.push(new GridHeader(this.$t('Email').toString(), 'courriel_autre', 'left', true, 200))
    this.headers.push(new GridHeader(this.$t('Success').toString(), 'success', 'center', true, 10))
    this.headers.push(new GridHeader(this.$t('Info').toString(), 'informations', 'center', true, 250))
  }

  private get exportFilename() {
    const filename = this.lastImportedFilename.split('.').slice(0, -1).join('.')
    return filename + '-resultats.xls'
  }

  private loadCSV() {
    (this.$refs.fileInput as any).value = null;
    (this.$refs.fileInput as any).click()
  }

  private onFilePicked(e: any) {
    this.users = []
    const file = e.target.files[0]
    if (file) {
      this.lastImportedFilename = file.name
      const formData = new FormData()
      formData.append('file', file)
      formData.append('username', this.currentUser.sAMAccountName)

      this.massCreation(formData)
    } else {
        const message = this.$t('ERROR.CSV.LoadFailed').toString()
        this.$notificationService.error(message)
    }
  }

  private async massCreation(formData: FormData) {
    let response
    try {
      this.isPending = true
      response = await TempAccountService.userMassInsert(formData)
      this.users = response.users
    } catch (error: any) {
      const status = error.response.status
      if (status === 400 || status === 500) {
        this.$notificationService.error(this.$t('USERMASSINSERT.CSVImportError').toString())
        return
      }
      response = error.response.data
      this.users = response.users
    } finally {
      this.exportCSV()
      this.isPending = false
    }
  }

  private errorCodeToString(errorCode: number) {
    return this.errorHandlerService.handle(this, errorCode, false)
  }

  // Export CSV
  private exportCSV() {
    let exception = null
    try {
      this.setCsvExportConfig()
      this.setUsers(this.users)
      if (this.usersToExport.length !== 0) {
        (this.$refs.downloadCSV as any).$el.click()
      }
    } catch (error: any) {
      exception = error
      this.$notificationService.error(this.$t('USERMASSINSERT.CSVExportError').toString())
    } finally {
      this.usersToExport = []
    }
  }

  /* tslint:disable:no-string-literal */
  private setCsvExportConfig() {
    this.jsonFields['identifiant'] = 'displayName'
    this.jsonFields['nom'] = 'sn'
    this.jsonFields['prenom'] = 'givenName'
    this.jsonFields['courriel_autre'] = 'mail'
    this.jsonFields['description'] = 'description'
    this.jsonFields['date_validite'] = 'End_date'
  }

  private setUsers(dataUsers: any) {
    let user
    for (const dataUser of dataUsers) {
      if (dataUser.success === true) {
        user = new UserCSV(
          dataUser.prenom,
          dataUser.nom,
          dataUser.identifiant,
          dataUser.description,
          dataUser.courriel_autre,
          dataUser.identifiant,
          dataUser.identifiant,
          this.formatDate(dataUser.date_validite, '-'),
          true,
          true,
        )
        this.usersToExport.push(user)
      }
    }
  }

  private formatDate(selectedDate: string, splitCharacter: string) {
    let formattedDate = ''
    if (selectedDate) {
      const [year, month, day] = selectedDate.split(splitCharacter)
      formattedDate = `${day}.${month}.${year}`
    }
    return formattedDate
  }

  private downloadTemplate() {
    window.open('/exemple.csv')
  }
}
